<div class="title">SIGN UP WITH XERO</div>
<div class="sub-title">
    Welcome to HUBTIGER! Just a moment, we are about to sign you in using Xero.
</div>
<div class="margin-top-48 text-center">
    <!-- <button type="button" class="btn btn-primary" (click)="startXeroSignup()" [disabled]="isLoading" style="margin-top:0;">
        <i class="fa fa-spin fa-spinner" *ngIf="isLoading"></i>
        <span *ngIf="!isLoading">Sign up with Xero</span>
    </button> -->

    <div class="spinner-container">
        <div class="spinner-border" role="status"></div>
    </div>
</div>
<div class="error" *ngIf="error">
    <span>{{errorMessage}}</span>
</div>